import React, { useContext } from 'react';
import { XRouterNavigateContext } from './seo/xrouter/XRouterNavigateContext';
import useIsLiveSection from './useIsLiveSection';
import { urls } from '..';
import { useFavorites } from './FavoritesProvider';
import { getLabel } from '../data/labels';

export default function OpenFavoritesButton() {
    const xrouterNavigateContext =  useContext(XRouterNavigateContext);
    const isLiveSection = useIsLiveSection();
    const favorites = useFavorites();

    function openFavorites(e) {
        e.preventDefault();
        e.stopPropagation();
        if (isLiveSection) {
            xrouterNavigateContext.navigate(`${urls.base}/${urls.live.base}/preferiti`, {});
        } else {
            xrouterNavigateContext.navigate(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/preferiti`, {});
        }
    }

    const favoritesSet = new Set(Object.keys(favorites));

    return (
        <div className="open-favorites-btn flex items-center justify-start ml-auto" onClick={openFavorites}>
            <i className="bi-star-fill text-md text-cs5"></i>
            <span className="ml-1 text-md text-cs1">{getLabel('general.favorites')} <span className='favorite-counter'>{favoritesSet.size}</span></span>
        </div>
    );
}
